var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c(
            "v-row",
            { staticClass: "d-flex" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-center align-center",
                  attrs: { md: "5", sm: "12" }
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mx-auto card-option fill-height",
                      attrs: { flat: "", "full-width": "" }
                    },
                    [
                      _c("v-img", {
                        staticClass: "white--text align-end fill-height",
                        attrs: {
                          src: require("@/assets/tickets-r3-req--network-security-internet.png")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-col", { staticClass: "mx-3", attrs: { cols: "6" } }, [
                _vm.generalInformation.category
                  ? _c("div", { staticClass: "ma-2 font-weight-light" }, [
                      _c(
                        "p",
                        [
                          _c("v-icon", [_vm._v("mdi-animation-outline")]),
                          _c("span", { staticClass: "mx-1" }, [
                            _vm._v("Categoría: ")
                          ]),
                          _c(
                            "span",
                            { staticClass: "font-weight-light mx-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.generalInformation.category.name)
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm.generalInformation.subCategory
                  ? _c("div", { staticClass: "ma-2 font-weight-light" }, [
                      _c(
                        "p",
                        [
                          _c("v-icon", [_vm._v("mdi-animation-outline")]),
                          _c("span", { staticClass: "mx-1" }, [
                            _vm._v("Sub-categoría: ")
                          ]),
                          _c(
                            "span",
                            { staticClass: "font-weight-light mx-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.generalInformation.subCategory.name)
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm.generalInformation.subject
                  ? _c("div", { staticClass: "ma-2 font-weight-light" }, [
                      _c(
                        "p",
                        [
                          _c("v-icon", [_vm._v("mdi-account-question")]),
                          _c("span", { staticClass: "mx-1" }, [
                            _vm._v("Asunto: ")
                          ]),
                          _c(
                            "span",
                            { staticClass: "font-weight-light mx-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.generalInformation.subject.name)
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "ma-2 font-weight-light" }, [
                  _c(
                    "p",
                    [
                      _c("v-icon", [_vm._v("mdi-account-tie")]),
                      _c("span", { staticClass: "mx-1" }, [
                        _vm._v("Contacto Solicitante:")
                      ]),
                      _c("span", { staticClass: "font-weight-light" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.generalInformation.firstName) +
                            " " +
                            _vm._s(_vm.generalInformation.lastName) +
                            " "
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm.generalInformation.description
                  ? _c("div", { staticClass: "ma-2 font-weight-light" }, [
                      _c(
                        "p",
                        [
                          _c("v-icon", [
                            _vm._v("mdi-comment-text-multiple-outline")
                          ]),
                          _c("span", { staticClass: "mx-1" }, [
                            _vm._v("Descripción del ticket:")
                          ]),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.generalInformation.description) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "float-right",
              attrs: { justify: "end", align: "center" }
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green", outlined: "" },
                      on: { click: _vm.reset }
                    },
                    [
                      _c(
                        "span",
                        { class: { caption: _vm.$vuetify.breakpoint.xsOnly } },
                        [_vm._v("Cancelar")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  class: { "mr-n3": _vm.$vuetify.breakpoint.xsOnly },
                  attrs: { cols: "4" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "green", outlined: "" },
                      on: { click: _vm.previousStep }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-chevron-left")]),
                      _c("span", { staticClass: "d-none d-sm-flex" }, [
                        _vm._v("Regresar")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "green", loading: _vm.isCreatingTicket },
                      on: { click: _vm.sendRequirementTicket }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-check-all")]),
                      _c("span", [_vm._v("Enviar")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }